import React from "react";
import { ButtonComp, TextInputComp, FormikDatePicker } from "../../../../../../components";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { AiOutlineClose } from "react-icons/ai";
import moment from "moment";

const MarkAsPaidWithdrawalModal = ({
  requestId,
  onMarkAsPaid,
  onClose,
  isLoading,
}) => {
  const handleSubmit = async (values, { resetForm }) => {
    await onMarkAsPaid(
      requestId,
      values.payment_date,
      values.payment_reference
    );
    resetForm();
  };

  return (
    <div className="relative p-4">
      <Formik
        initialValues={{
          payment_date: moment().format("YYYY-MM-DD"),
          payment_reference: "",
        }}
        validationSchema={Yup.object({
          payment_date: Yup.date()
            .required("Payment date is required")
            .max(moment().format("YYYY-MM-DD"), "Payment date cannot be in the future"),
          payment_reference: Yup.string().max(255, "Reference is too long"),
        })}
        onSubmit={handleSubmit}
      >
        <Form className="">
          <AiOutlineClose
            onClick={onClose}
            className="absolute top-10 left-5"
            style={{ cursor: "pointer", fontSize: "20px", color: "var(--color-primary)" }}
          />
          <h4 className="border-b fw-bold py-2 mb-4 text-[1.5rem] !text-primary text-center w-full">
            Mark Withdrawal as Paid
          </h4>
          <div className="mb-3">
            <FormikDatePicker
              fieldName={"payment_date"}
              labelClassName={"fw-2"}
              LabelText={"Payment Date"}
              maxDate={moment().toDate()}
            />
          </div>
          <div className="mb-3">
            <TextInputComp
              name={"payment_reference"}
              LabelText={"Payment Reference (Optional)"}
              LabelClassName={"fw-2"}
              type={"text"}
              placeholder={"Enter payment reference or transaction code"}
              borderColor={"#A1A0A0"}
            />
          </div>
          <div className="row justify-content-around pt-4">
            <div className="col-5">
              <ButtonComp
                btnText={"Cancel"}
                btnClassName={"text-1 btn w-100 py-2"}
                BorderColor={"var(--color-primary)"}
                onClick={onClose}
              />
            </div>
            <div className="col-5">
              <ButtonComp
                loading={isLoading}
                type="submit"
                btnText={"Mark as Paid"}
                ButtonInlineStyle={{ backgroundColor: "#19BC31" }}
                btnClassName={"border-0 text-white w-100 py-2 rounded"}
              />
            </div>
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default MarkAsPaidWithdrawalModal;

